import * as angular from "angular";
import {IController} from "angular";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import * as _ from "lodash";
import {BranchModel} from "../../models/branch.model";

export class branchesTableCtrl implements IController {

  queryString: String;
  branchIds: any;
  tags: string[];
  isActive: boolean;
  allowSelect: boolean;
  excludeMode: boolean;
  selectedIds: string[];
  canRemove: Function;
  doReload: Function;
  onReload: Function;
  onEdit: Function;
  onRemove: Function;
  onSelectBranchesChange: Function;

  private branchesRef: any;
  private loadLimit = 30;
  private infiniteScroll: any;
  public selectedKeys: any;

  /* @ngInject */
  constructor(private $infiniteScroll, private $branches, private $log, private commonsAlertsService: CommonsAlertsService) {
  }

  $onInit() {
    this.branchesRef = this.$branches();
    this.branchesRef.$query(this._getPaginationParams());
    this.infiniteScroll = this.$infiniteScroll(this.branchesRef, this.loadLimit, this._getInfiniteScrollConfig());
    this.initSelectedKeys();
  };

  $onChanges(changes) {
    if ((changes.doReload && !changes.doReload.isFirstChange()) ||
      (changes.branchIds && !changes.branchIds.isFirstChange()) ||
      (changes.tags && !changes.tags.isFirstChange()) ||
      (changes.isActive && !changes.isActive.isFirstChange()) ||
      (changes.queryString && !changes.queryString.isFirstChange())) {
      this._loadBranches();
    }

    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.initSelectedKeys();
    }
  };

  onToggleSelectAll() {
    // this.selectedKeys = {};
    this.onSelectBranchesChange({
      selectedIds: [],
      excludeMode: !this.excludeMode
    });
  }

  onToggleBranchSelect(branch: BranchModel) {
    this.selectedKeys[branch.id] = !this.selectedKeys[branch.id];
    this.onSelectBranchesChange({
      selectedIds: _.keys(_.pickBy(this.selectedKeys, _.identity)),
      excludeMode: this.excludeMode
    });
  }

  /////////////////////////////////////////////////////////////////////

  // ******************************
  //        Private methods
  // ******************************

  private initSelectedKeys() {
    this.selectedKeys = {};
    _.forEach(this.selectedIds, (selectedId) => {
      this.selectedKeys[selectedId] = true;
    });
  }

  _loadBranches() {
    this.branchesRef.$query(this._getPaginationParams())
      .then(() => {
        this.infiniteScroll.reload(this._getInfiniteScrollConfig());
        this.onReload();
      })
      .catch((error) => {
        this.commonsAlertsService.somethingWentWrongError();
        this.$log.error('Failed to load branches @branchesTable@_loadBranches', error);
      })
  }

  _getPaginationParams() {
    return {
      limit: this.loadLimit
    }
  }

  _getInfiniteScrollConfig() {
    return {
      data: this._getFilterPayload()
    }
  }

  _getFilterPayload() {
    return {
      ids: this.branchIds,
      tags: this.tags,
      isInactive: _.isBoolean(this.isActive) ? !this.isActive : undefined,
      query: this.queryString
    }
  }

}

angular
  .module('bringoz.admin.branches')
  .component('branchesTable', {
    bindings: {
      queryString: '<?',
      branchIds: '<?',
      tags: '<?',
      isActive: '<?',
      canRemove: '<',
      doReload: '<',
      excludeMode: '<',
      selectedIds: '<',
      allowSelect: '<?',
      onSelectBranchesChange: '&',
      onReload: '&',
      onEdit: '&',
      onRemove: '&'
    },
    template: require('./branches-table.html').default,
    controller: branchesTableCtrl
  });
